import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Youtube from './Youtube';

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>Ta-Daaahhhhh......Trailer Movies</h2>
        </div>
        <Youtube/>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js